import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from '../../../../../models/base/base-component';
import {Guide} from '../../../../../models/shared/guide';
import ResizeObserver from 'resize-observer-polyfill';
import {AssetComponent} from '../../../../../views/shared/components/asset/asset.component';
import {BehaviorSubject} from 'rxjs';
import {TypeUtils} from '../../../utils/type-utils';
import {NavigatorService} from '../../../../../services/navigator.service';
import {ScreenService} from '../../../../../services/screen.service';

@Component({
  selector: 'app-guide-feature-card',
  templateUrl: './guide-feature-card.component.html',
  styleUrls: ['./guide-feature-card.component.scss'],
})
export class GuideFeatureCardComponent extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy {

  @Input() guide: Guide;
  @ViewChild('asset') asset: AssetComponent;
  types = TypeUtils;
  private assetObserver: ResizeObserver;
  public assetHeight = new BehaviorSubject<string>(null);
  public isMobile: boolean = false;

  constructor(
    private navigator: NavigatorService,
    private el: ElementRef,
    private screenService: ScreenService
  ) {
    super();
  }

  ngOnInit(): void {
    this.setupViews();
  }

  setupViews() {
  }

  ngAfterViewInit(): void {
    this.setupBindings();
  }

  setupBindings() {
    this.bindToResize();
    this.bindToMobile();
  }

  private bindToMobile() {
    const mobileSub = this.screenService.connectToIsMobile().subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
    this.pushSub(mobileSub);
  }

  private bindToResize() {
    this.assetObserver = new ResizeObserver((entries, _) => {
      for (const entry of entries) {
        const cr = entry.contentRect;
        const height = cr.height;
        const width = cr.width;
        const heightShouldBe = Math.floor(width);
        if (heightShouldBe !== height) {
          this.assetHeight.next(`${heightShouldBe}px`);
        }
      }
    });
    this.assetObserver.observe(this.asset.el.nativeElement);
  }

  public goToGuide() {
    this.navigator.toGuide(this?.guide);
  }

  ngOnDestroy(): void {
    this.assetObserver.disconnect();
    this.destroy();
  }

}
